import { render } from "./delays_section.vue?vue&type=template&id=6e9c9d43"
import script from "./delays_section.vue?vue&type=script&lang=js"
export * from "./delays_section.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__